// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import Input from './Input';
import ThemeMode from '@/types/theme-mode';
import Nullable from '@/types/nullable';

interface Props {
  onChange: (value: string) => void;
  onFocus?: (event: React.FocusEvent) => void;
  onBlur?: (event?: React.FocusEvent) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  compact?: boolean;
  onSubmit?: () => void;
  loading?: boolean;
  filtersDropdown?: any;
  rightSection?: JSX.Element;
  leftSection?: Nullable<JSX.Element>;
  value?: string;
  dark?: boolean;
  theme?: ThemeMode;
  role?: string;
  'aria-expanded'?: boolean;
  'aria-controls'?: string;
  'aria-autocomplete'?: string;
}

class SearchInput extends React.Component<Props> {
  input = React.createRef<Input>();

  static defaultProps = {
    onChange: () => {},
    disabled: false,
  };

  getInputValue = () => {
    if (!this.input.current) {
      return '';
    }

    return this.input.current.getInputValue();
  };

  getInputLeftSection = () => {
    const icon = this.props.loading ? 'icon-spinner' : 'icon-search';

    if (this.props.leftSection === null) {
      return <></>;
    }

    return (
      <div className="d-flex align-items-center">
        <i className={icon} />

        {this.props.leftSection}
      </div>
    );
  };

  getInputRightSection = () => {
    if (!this.props.rightSection) {
      return <></>;
    }

    return <div className="d-flex align-items-center">{this.props.rightSection}</div>;
  };

  blurInput = () => {
    if (this.input.current) {
      this.input.current.blur();
    }
  };

  focusInput = () => {
    if (this.input.current) {
      this.input.current.focus();
    }
  };

  render() {
    return (
      <Input
        data-private
        data-dd-privacy="mask"
        ref={this.input}
        dark={this.props.dark}
        theme={this.props.theme}
        onSubmit={this.props.onSubmit}
        compact={this.props.compact}
        className={classNames(this.props.className, 'search-input')}
        disabled={this.props.disabled}
        placeholder={this.props.placeholder}
        onValueChange={this.props.onChange}
        rightSection={this.getInputRightSection()}
        leftSection={this.getInputLeftSection()}
        value={this.props.value}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        data-testid="searchInput-input-searchBar"
        type="search"
        label={this.props.placeholder}
        hasHiddenLabel
        autoComplete="off"
        role={this.props.role || 'searchbox'}
        aria-expanded={this.props['aria-expanded']}
        aria-controls={this.props['aria-controls']}
        aria-autocomplete={this.props['aria-autocomplete']}
      />
    );
  }
}

export default SearchInput;
